// Recommendation credit (see music/referral_service.py on the server).
// When a listener reaches music through someone's profile, post or shared
// link, we tell the server who recommended it; the server checks the claim
// and, for an artist new to the listener, credits the recommender.
import { ApiRoutes } from '../constants/routes';
import { mutation } from './api';

const PENDING_KEY = 'tuneswell:pending-referral';

const isSignedIn = () => {
  try {
    return !!localStorage.getItem('token');
  } catch {
    return false;
  }
};

// source 'profile' | 'share': recommender (uuid), contentType ('track' |
// 'album' | 'act') and contentId. source 'post': just postId - the server
// reads the rest from the post. Resolves once recorded (await it before
// playing, so the play is credited); never rejects - it's bookkeeping.
export const claimReferral = ({ recommender, contentType, contentId, source, postId }) => {
  const complete = source === 'post' ? !!postId : !!(recommender && contentType && contentId);
  if (!complete) return Promise.resolve();
  const claim = {
    recommender,
    content_type: contentType,
    content_id: contentId,
    source,
    ...(postId ? { post_id: postId } : {}),
  };
  if (!isSignedIn()) {
    // Someone opened a shared link before signing in - claim it once they do
    try {
      localStorage.setItem(PENDING_KEY, JSON.stringify(claim));
    } catch {
      // Storage unavailable; nothing to remember it in
    }
    return Promise.resolve();
  }
  return mutation(ApiRoutes.ClaimReferral, claim).catch(() => {});
};

// Called once the user is signed in
export const claimPendingReferral = () => {
  let claim = null;
  try {
    claim = JSON.parse(localStorage.getItem(PENDING_KEY) || 'null');
    localStorage.removeItem(PENDING_KEY);
  } catch {
    return;
  }
  if (claim) mutation(ApiRoutes.ClaimReferral, claim).catch(() => {});
};

// A public link to share, tagged with who shared it
export const withShareReferral = (url, user) => {
  if (!user?.uuid) return url;
  const link = new URL(url, window.location.origin);
  link.searchParams.set('ref', user.uuid);
  return link.toString();
};

// For pages people land on from a shared link (?ref=<uuid>)
export const claimShareReferral = (contentType, contentId, currentUser) => {
  const recommender = new URLSearchParams(window.location.search).get('ref');
  if (!recommender || recommender === currentUser?.uuid) return;
  claimReferral({ recommender, contentType, contentId, source: 'share' });
};
